<template>
  <skutopia>
    <v-card >
        <v-card-title>
            POG List
        </v-card-title>
        <!-- actions -->
         <v-card-text>

            <!-- <v-navigation-drawer
                v-model="filterDrawer"
                absolute
                width="300"
                class="elevation-10"
                style="z-index: 10;"
            >
                <v-list dense class="filter-list-content">
                    <v-subheader>
                        Filters
                        <v-spacer></v-spacer>
                        <v-btn icon small @click="filterDrawer = false"><v-icon>{{icons.mdiClose}}</v-icon></v-btn>
                    </v-subheader>
                    
                </v-list>
            </v-navigation-drawer>
            <v-btn
                v-if="!filterDrawer"
                absolute
                top
                left
                small
                fab
                color="white"
                class="mt-2 ml-2"
                style="z-index: 5"
                @click="filterDrawer = true"
                >
                    <v-icon>{{icons.mdiFormatListBulleted}}</v-icon>
                </v-btn> -->

            <v-row>
                <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                        v-model="selectedCategory"
                        :items="categoryOptions"
                        :loading="categoryLoading"
                        item-text="name"
                        item-value="id"
                        dense
                        outlined
                        label="Category"
                        placeholder="Select Category"
                        clearable
                        @change="changeCategory"
                    >

                    </v-autocomplete>
                </v-col>
            </v-row>

         </v-card-text>
        <v-card-text class="d-flex align-center flex-wrap pb-0 mt-4">
          <v-row>
            <!-- search -->
            <v-col
              cols="12"
              sm="4"
            >
            <v-form
                @submit="submitSearch($event)"
            >
                <v-text-field
                    v-model="searchQuery"
                    placeholder="Search"
                    outlined
                    hide-details
                    dense
                    clearable
                    class="mb-4"
                    :append-icon="icons.mdiSend"
                    @click:append="submitSearch"
                    @click:append-outer="submitSearch"
                    @click:clear="submitSearch(event=null)"
                >
                </v-text-field>

            </v-form>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex align-center">
            <v-checkbox
                v-model="pogCompletedStatus"
                label="Show completed only"
                hide-details
                dense
                class="mb-4 mt-0 pt-0"
                @change="submitSearch"
            ></v-checkbox>
        </v-col>
          <v-col
              cols="12"
              sm="4"
            >
                <div
                    class=" d-flex flex-column align-end"
                >
                    <v-btn
                        :prepend-icon="icons.mdiDownload"
                        dense
                        color="primary"
                        @click="isUploadDialogVisible = !isUploadDialogVisible"
                        v-if="$can('update','skutopia')"
                    >
                        Upload New POG
                    </v-btn>
                </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="px-0">

            <!-- table -->
            <v-data-table
                :headers="POGHeaders"
                :items="planogramsData"
                :server-items-length="totalPOGs"
                :loading="pogLoading"
                :options.sync="options"
                :footer-props="{
                    'items-per-page-options':[options.itemsPerPage],
                    'disable-items-per-page': true,
                }"
            >

                <!-- POG ID -->
                <template #item.id="{ item }">
                    <router-link :to="{ name: 'planogram-id', params: { id: item.id } }">
                        #{{ item.id }}
                    </router-link>

                </template>

                <!-- Date -->
                <template #item.project="{ item }">
                    <div class="d-flex align-center gap-x-4 cursor-pointer"

                    >
                        <v-avatar
                            v-if="item.shelf_thumbnail"
                            size="38"
                            rounded
                            class="mr-3"
                            @click="openOverlay(item)"
                        >
                            <v-img
                                :alt="item.shelf_thumbnail"
                                :src="item.shelf_thumbnail"
                                contain
                            ></v-img>
                        </v-avatar>
                        <div class="d-flex flex-column">
                            <span>{{ item.name }}</span>
                            <span>{{ item.project }} - {{ item.country }}</span>
                        </div>
                    </div>
                </template>
                <!-- Date -->
                <template #item.created_at="{ item }">
                    {{ new Date(item.created_at).toDateString() }}
                </template>


                <!-- Products -->
                <template #item.products="{ item }">
                <div
                    class="d-flex align-center font-weight-medium"
                >
                    <v-icon
                        size="10"
                        class="me-2"
                        :color="resolveStatus(item.status).color"
                    >{{icons.mdiCircle}}</v-icon>
                    <div class="d-flex flex-column">
                        <span>{{ item.products }} products</span>
                        <span
                            v-if="item.missing_images > 0 && item.status !== 'COMP'"
                            class="error--text">
                            {{ item.missing_images }} missing
                        </span>
                    </div>
                </div>
                </template>

                <!-- Status -->
                <template #item.status="{ item }">
                    <v-chip
                        v-bind="resolveStatus(item.status)"
                        small
                    >{{resolveStatus(item.status).text}}</v-chip>
                </template>


                <!-- Actions -->
                <template #item.actions="{ item }">
                <v-menu
                    bottom
                    left
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                    </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                            :to="{name: 'planogram-id', params: { id: item.id }}"
                            target="_blank"
                        >
                            <v-list-item-title>
                                <v-icon
                                    size="20"
                                    class="me-2"
                                >
                                    {{ icons.mdiPencilBoxOutline }}
                                </v-icon>
                                <span>Edit</span>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>

                            <v-list-item-title>
                            <v-icon
                                size="20"
                                class="me-2"
                            >
                                {{ icons.mdiDownload }}
                            </v-icon>
                            <span>Download</span>
                            </v-list-item-title>
                        </v-list-item>


                        <v-list-item
                            @click="deletePOG(item.id)"
                            v-if="$can('update','skutopia')"
                        >
                            <v-list-item-title>
                                <v-icon
                                    size="20"
                                    class="me-2"
                                >
                                    {{ icons.mdiTrashCanOutline }}
                                </v-icon>
                                <span>Delete</span>
                            </v-list-item-title>
                        </v-list-item>

                        <!-- <v-list-item
                        
                        v-if="$can('update','skutopia')">
                            <v-list-item-title>
                                <v-icon
                                    size="20"
                                    class="me-2"
                                >
                                    {{ icons.mdiLayersTripleOutline }}
                                </v-icon>
                                <span>Duplicate</span>
                            </v-list-item-title>
                            </v-list-item> -->


                    </v-list>
                </v-menu>

                </template>
            </v-data-table>

        </v-card-text>
    </v-card>
    <v-dialog
        v-model="isUploadDialogVisible"
        max-width="700px"
        peristent
    >
        <v-card class="text-center px-10 py-6">
            <v-form
                ref="POGForm"
                @submit.prevent=""
            >
                <v-card-title>
                    Please select your project and upload POG file
                </v-card-title>
                <v-card-text>
                        <v-autocomplete
                            v-model="projectSelected"
                            :items="projects"
                            :loading="projectLoading"
                            :search-input.sync="projectSearch"
                            item-value="id"
                            label="Find Project"
                            outlined
                            dense
                            @change="projectSearch=''"
                            return-object>
                                <template #no-data>
                                    <p class="ml-2" style="color: gray">No results found</p>
                                </template>
                        </v-autocomplete>
                </v-card-text>
                <v-card-text>
                    <div class="flex">
                        <div class="w-full h-auto relative">
                        <div
                            ref="dropZoneRef"
                            class="cursor-pointer"
                            @click="() => openFile()"
                        >
                            <div
                            class="d-flex flex-column justify-center align-center gap-y-2 pa-2 drop-zone rounded"
                            >
                            <v-btn
                                oulined
                                color="secondary"
                                class="rounded"
                                size="30"
                            >
                                <v-icon
                                size="24"
                                >{{ icons.mdiTrayArrowUp }}</v-icon>
                            </v-btn>
                            <span class="text-h6">
                                Click to upload your POG File here.
                            </span>

                            </div>

                            <div class="drop-zone"
                            >
                                <v-list-item
                                    v-for="(item, index) in fileData"
                                    :key="index"
                                    @click.stop
                                >
                                    <!-- File name -->
                                    <v-list-item-title>
                                        {{ item.name }}
                                    </v-list-item-title>
                                    <!-- File extension -->
                                    <v-list-item-subtitle>
                                        {{ item.type }}
                                    </v-list-item-subtitle>

                                    <template v-slot:append>
                                        <v-list-item-action class="align-end">
                                            <v-btn
                                            @click.stop="fileData.splice(index, 1)"
                                            >X</v-btn>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </div>
                        </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        outlined
                        class="mr-2"
                        @click="initPOGUpload"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="mr-2"
                        @click="uploadPOG"
                        :disabled="!(projectSelected && projectSelected.id != undefined && fileData.length == 1)"
                    >
                        Upload
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <v-dialog v-model="overlayOpen" width="80%" >  <!-- Full-size image dialog -->
        <v-card>
            <v-card-title>
            {{ selectedPOG ? `${selectedPOG.project} - ${selectedPOG.country} - POG #${selectedPOG.id}` : '' }}
            </v-card-title>

            <v-img
                :src="selectedPOG.shelf_thumbnail || selectedPOG"
                :lazy_src="selectedPOG.shelf_thumbnail || selectedPOG"
                max-height="80vh"
                max-width="100%"
                contain
            >
            <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                    color="grey-lighten-4"
                    indeterminate
                ></v-progress-circular>
                </div>
            </template>
            </v-img>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeOverlay">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </skutopia>
</template>

<script>
import store from '@/store'
import { onMounted, ref, onUnmounted, computed, watch } from '@vue/composition-api'
import {
  mdiSend,
  mdiClose,
  mdiPencil,
  mdiDelete,
  mdiFormatListBulleted,
  mdiPencilBoxOutline,
  mdiDownload,
  mdiTrashCanOutline,
  mdiLayersTripleOutline,
  mdiCircle,
  mdiFoodOutline,
  mdiBeerOutline,
  mdiBabyBottleOutline,
  mdiBottleTonicPlusOutline,
  mdiHomeHeart,
  mdiToyBrickOutline,
  mdiPaw,
  mdiTshirtCrewOutline,
  mdiTrayArrowUp,
  mdiDotsVertical,
} from '@mdi/js'

import Skutopia from '@/views/apps/skutopia/Skutopia.vue'
import usePOG from '../usePOG'
import projectStoreModule from '@/views/apps/project/projectStoreModule'

export default {
    components: {
        Skutopia
    },
    setup() {


        const PROJECT_APP_STORE_MODULE_NAME = 'app-project'

        // Register module
        if (!store.hasModule(PROJECT_APP_STORE_MODULE_NAME)) store.registerModule(PROJECT_APP_STORE_MODULE_NAME, projectStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
        if (store.hasModule(PROJECT_APP_STORE_MODULE_NAME)) store.unregisterModule(PROJECT_APP_STORE_MODULE_NAME)
        })

        const filterDrawer = ref(false)
        const POGHeaders = ref([
            {
                text: 'POG',
                value: 'id',
            },
            {
                text: 'PROJECT',
                value: 'project',
            },
            {
                text: 'CATEGORY',
                value: 'category',
            },
            {
                text: 'PRODUCTS',
                value: 'products',
            },
            {
                text: 'STATUS',
                value: 'status'
            },
            {
                text: 'CREATION DATE',
                value: 'created_at',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
            },
        ])
        const selectedCategory = ref(null)
        const isUploadDialogVisible = ref(false)
        const fileData = ref([])

        const projectLoading = ref(false)
        const projectSelected = ref(null)
        const projectSearch = ref("")
        const dropZoneRef = ref()
        const selectedPOG = ref({})
        const overlayOpen = ref(false)
        const pogCompletedStatus = ref(false)

        const {
            planogramsData,
            resolveStatus,
            options,
            searchQuery,
            pogLoading,
            totalPOGs,
            planogramUploadLoading,
            lighthouseProjectsData,
            totalProjectListTable,

            categoryOptions,
            categoryLoading,
            categorySearch,
            fetchCategories,

            fetchProjects,
            fetchPOGs,
            addPOG,
            deletePOG
        } = usePOG()

        const projects = computed(() => lighthouseProjectsData.value.map(project => {
            const countries = project.countries
            return countries.map(country => {
                return {
                    id:country.id,
                    text: `${project.job_number} ${project.job_name} - ${country.country_detail.code}`,
                    job_number: project.job_number,
                    job_name: project.job_name,
                    category: project.category.name,
                    country: country.country_detail.name,
                    country_code:country.country_detail.code
                }
            })}).flat()
        )


        const initPOGUpload = () => {
            projectSelected.value = null
            projectSearch.value = ''
            fileData.value = []
            isUploadDialogVisible.value = false
        }


        const changeCategory = (category) => {
            pogLoading.value = true
            const params = {
                category: category
            }
            fetchPOGs(params)
        }

        const submitSearch = (event) => {
            if (event && typeof event.preventDefault === 'function') {
                event.preventDefault()
            }
            const params = {}

            if (searchQuery.value) {
                params.search = searchQuery.value
            }
             if (pogCompletedStatus.value) {
                params.status = 'COMP'
            }
            pogLoading.value = true
            fetchPOGs(params)
        }


        const openFile = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.accept = 'text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
            input.onchange = _ => {
                // you can use this method to get file and perform respective operations
                fileData.value = Array.from(input.files);


            };
            input.click();
        }

        const uploadPOG = () => {
            const project = JSON.parse(JSON.stringify(projectSelected.value))
            console.log(project)
            addPOG(project, fileData.value[0])
        }

        const openOverlay = (pog) => {
            selectedPOG.value = pog
            overlayOpen.value = true;
        }

        const closeOverlay = () =>  {
            overlayOpen.value = false;
            selectedPOG.value = null; // Clear the selected image
        }


        watch(projectSearch,
            async (val, oldVal) => {
                if (val != null && val.length > 2 && projectSelected.value == null) {

                    projectLoading.value = true
                    await fetchProjects(val)

                    projectLoading.value = false
                }
            }
        )

        onMounted(async () => {
            // await fetchPOGs()
            await fetchCategories()
        })

        
        watch([options], () => {
            fetchPOGs()
        })

        return {
            filterDrawer,
            POGHeaders,
            planogramsData,
            resolveStatus,
            options,
            searchQuery,
            pogLoading,
            totalPOGs,
            selectedCategory,
            categoryOptions,
            categoryLoading,
            categorySearch,
            isUploadDialogVisible,
            fileData,
            dropZoneRef,
            projectSelected,
            projectSearch,
            projectLoading,
            projects,
            selectedPOG,
            overlayOpen,
            pogCompletedStatus,

            initPOGUpload,
            uploadPOG,
            openFile,
            deletePOG,
            openOverlay,
            closeOverlay,
            submitSearch,
            changeCategory,

            icons: {
                mdiSend,
                mdiPencilBoxOutline,
                mdiDownload,
                mdiTrashCanOutline,
                mdiLayersTripleOutline,
                mdiDotsVertical,
                mdiCircle,
                mdiTrayArrowUp,
                mdiClose,
                mdiPencil,
                mdiDelete,
                mdiFormatListBulleted
            }
        }
    }

}
</script>


<style lang="scss" scoped>
.drop-zone {
  border: 1px dashed rgba(33,33,33, 0.4);
}
</style>